
export const optimizeImage = (src, width, height) => {
  const params = new URLSearchParams();
  if (width) params.append("w", width);
  if (height) params.append("h", height);
  return `${src}?${params.toString()}`;
};
